import styled from 'styled-components';
import { spacing } from '~/theme';
import colors from '~/theme/variables/colors';
import PasswordShow from '~/assets/icons/ontario-icon-password-show.svg';
import PasswordHide from '~/assets/icons/ontario-icon-password-hide.svg';

export const StyledPasswordShow = styled(PasswordShow)`
    margin-right: ${spacing.spacing4};
    path {
        fill: ${colors.darkBtnBG};
    }
    cursor: pointer;
`;

export const StyledPasswordHide = styled(PasswordHide)`
    margin-right: ${spacing.spacing4};
    path {
        fill: ${colors.darkBtnBG};
    }
    cursor: pointer;
`;
